import { modifier } from 'ember-modifier';
import tippy from 'tippy.js';

const appendTo = () => document.body;

/**
 *
 */
export default modifier((element, _, props) => {
  const { content } = props;

  if (!content) {
    return;
  }

  const {
    allowHTML = false,
    interactive = false,
  } = props;

  const instance = tippy(element, {
    allowHTML,
    appendTo,
    content,
    interactive,
    ignoreAttributes: true,
  });

  return () => {
    instance.destroy();
  };
}, { eager: false });
